import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'
import {
    QUAYSO1,
    QUAYSO2,
    QUAYSO3,
    NUMBERGAME1,
    NUMBERGAME2,
    KENOSIEUTOC,
    KENOVIETLOTT,
    LODE3MIEN,
    LODESIEUTOC,
    ESPORT,
    VSPORT,
    QUICK_GAME,
} from '~/constants/apiLink'

export const useFrameStore = defineStore('frameStore', () => {
    const fetcher = useCustomFetch()

    const theFrameUrl = ref('')
    const theLinkType = ref(null)

    const getFrameUrl = async (link) => {
        let temp = link || theLinkType.value
        theLinkType.value = temp
        let urlGetLink = ''
        switch (temp) {
            case QUAYSO1:
                urlGetLink = '/athena/kenoUrl'
                break
            case QUAYSO2:
                urlGetLink = '/athena/lotteryUrl'
                break
            case QUAYSO3:
                urlGetLink = '/athena/numberGameUrl'
                break
            case NUMBERGAME1:
                urlGetLink = '/tp/numberGameUrl'
                break
            case NUMBERGAME2:
                urlGetLink = '/tp/numberGame2Url'
                break
            case KENOSIEUTOC:
                urlGetLink = '/tp/kenoUrl'
                break
            case KENOVIETLOTT:
                urlGetLink = '/tp/kenoVLUrl'
                break
            case LODE3MIEN:
                urlGetLink = '/lodeUrl'
                break
            case LODESIEUTOC:
                urlGetLink = '/lodeVirtualUrl'
                break
            case ESPORT:
                urlGetLink = '/athena/esportsUrl'
                break
            case VSPORT:
                urlGetLink = '/vsportsUrl'
                break
            case QUICK_GAME:
                urlGetLink = '/athena/tableGameUrl'
                break
            default:
                break
        }
        const { data } = await getLink(urlGetLink)
        return { data: data }
    }
    const getLink = async (link) => {
        try {
            const { data } = await fetcher.get(link)
            if (data.value.status === 'OK') {
                theFrameUrl.value = data.value.data.url
                return { data: data }
            } else {
                theFrameUrl.value = ''
                // return an empty ref
                return { data: ref(null) }
            }
        } catch (error) {
            theFrameUrl.value = ''
            //todo: handle error
            console.log('getLink - error')
            console.error(error)
        }
    }

    const restFrameUrl = () => {
        theFrameUrl.value = ''
        theLinkType.value = null
    }

    return {
        theFrameUrl,
        theLinkType,
        getFrameUrl,
        restFrameUrl,
    }
})
